import * as React from "react";
import {Modal} from "web-com";

interface IProps {
    active?: boolean;
    onSubmit?: () => void;
    msg?: string;
}

const Popup = (props: IProps) => {
    return (
        <div className="bs-popup">
           <Modal
                active={props.active}
                onSubmit={props.onSubmit}
                submitTitle="OK"
                title="Bank Statement pdf"

            >
               <div className="content">
                   {props.msg}
               </div>
           </Modal>
         </div>
    );
};

export default Popup;
